import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../firebase/client";
import type { SubPair, Substitution } from "../types/substitutions.types";

export function useSubstitutions(broadcastId: string | null): Substitution[] {
	const [substitutions, setSubstitutions] = useState<Substitution[]>([]);

	useEffect(() => {
		if (!broadcastId) return;

		const q = query(
			collection(db, "broadcasts", broadcastId, "substitutions"),
			orderBy("date", "asc"),
		);

		const unsubscribe = onSnapshot(q, (snapshot) => {
			setSubstitutions(
				snapshot.docs.map((doc) => {
					const data = doc.data() as {
						team: "home" | "away";
						date: string;
						subs?: SubPair[];
						playerOut?: string;
						playerIn?: string;
					};
					// Backward compat: old docs have playerOut/playerIn directly
					const subs = data.subs ?? [{ playerOut: data.playerOut!, playerIn: data.playerIn! }];
					return { id: doc.id, team: data.team, date: data.date, subs };
				}),
			);
		});

		return unsubscribe;
	}, [broadcastId]);

	return substitutions;
}
